export default __webpack_public_path__ + "static/media/Background.512bc0f1.png";